__turbopack_context__.v({
  "rowValue": "styles-module__ebAwDW__rowValue",
  "table": "styles-module__ebAwDW__table",
});
